import React from 'react';
import { useCustomComponent } from '@/hooks';

export interface PhoneInputCountrySelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {}

const CountrySelectComponent: React.FC<PhoneInputCountrySelectProps> = props => {
  return <select autoComplete="off" {...props} />;
};

export const CountrySelect: React.FC<PhoneInputCountrySelectProps> = (
  props: PhoneInputCountrySelectProps
) => {
  const Component = useCustomComponent({
    componentName: 'PhoneInputCountrySelect',
    Component: CountrySelectComponent,
  });

  return <Component {...props} />;
};


